import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, InputAdornment, Box } from '@mui/material';
import { HandymanOutlined } from '@mui/icons-material';
import { useFacilityMaintenanceEditor } from '../../../../../hooks/useFacilityMaintenanceEditor';
import { useGetRepairableByOptionsQuery } from '../../../../../../../services/DimensionService/dimensionApi';
import { EditorMode } from '../../../../../types/editorTypes';

interface Props {
  mode: EditorMode;
}

export const FacilityMaintenanceRepairableByEditor: React.FC<Props> = ({ mode }) => {
  const { request, updateRequest } = useFacilityMaintenanceEditor(mode);
  const { data: options = [], isLoading } = useGetRepairableByOptionsQuery();
  const labelId = `${mode}-facility-repairable-by-label`;

  const handleChange = (value: string) => {
    updateRequest({ repairableBy: value });
  };

  return (
    <Box sx={{ flex: 1 }}>
      <FormControl size="small" fullWidth>
        <InputLabel id={labelId}>Repairable By</InputLabel>
        <Select
          labelId={labelId}
          value={request?.repairableBy || ''}
          onChange={(e) => handleChange(e.target.value)}
          label="Repairable By"
          disabled={isLoading}
          startAdornment={
            <InputAdornment position="start">
              <HandymanOutlined sx={{ color: '#64748b', fontSize: 18 }} />
            </InputAdornment>
          }
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default FacilityMaintenanceRepairableByEditor;
